import { render, staticRenderFns } from "./loading-float.vue?vue&type=template&id=188165bc&"
import script from "./loading-float.vue?vue&type=script&lang=js&"
export * from "./loading-float.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports